var React = require('react');

function YourFirstDay (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 2a.5.5 0 0 0-1 0v1H4a2 2 0 0 0-2 2v14a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 19V5a2 2 0 0 0-2-2h-2.5V2a.5.5 0 0 0-1 0v1h-4V2a.5.5 0 0 0-1 0v1h-4V2zm13 3v2.5h-17V5a.5.5 0 0 1 .5-.5h16a.5.5 0 0 1 .5.5zm-17 14V9h17v10c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25zm6.526-1.445c0 .427.22.64.66.64h3.47c.434 0 .65-.213.65-.64 0-.42-.216-.63-.65-.63h-.91v-5.24c0-.207-.06-.363-.18-.47-.113-.107-.27-.16-.47-.16-.14 0-.283.027-.43.08-.14.053-.28.123-.42.21l-1.39.84c-.186.12-.296.267-.33.44a.676.676 0 0 0 .07.47.62.62 0 0 0 .35.3c.154.053.327.023.52-.09l.73-.44v4.06h-1.01c-.44 0-.66.21-.66.63z","fill":"#fff"}));
}

YourFirstDay.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = YourFirstDay;

YourFirstDay.default = YourFirstDay;
